import { ProductType } from 'common/api/e-comm/models/Product';
import { Option, FilterGroup, SortOptions, CardWithBrand, SortOption } from './types';
import { Card } from 'common/api/e-comm/models/Card';

// Constant options for the CardType filter, the data structure to save the filters is a Set
// therefore having these pre-defined in 1 place makes it easier to refactor but also use the
// `has` function to test membership.
export const allCards: Option = { text: 'All Cards', value: 'all', group: FilterGroup.cardType };
export const eGift: Option = {
    text: 'eGift',
    value: ProductType.EGiftCard as string,
    group: FilterGroup.cardType,
};
export const reload: Option = {
    text: 'Reload',
    value: ProductType.Reload as string,
    group: FilterGroup.cardType,
};

// Sort Constants
export const sortOptions: SortOptions = {
    addedRecentlyOption: { text: 'Added Recently', value: 'addedRecently' },
    amountDescOption: { text: 'Amount $$$$-$', value: 'amount:desc' },
    amountAscOption: { text: 'Amount $-$$$$', value: 'amount:asc' },
    nameOption: { text: 'Name (A-Z)', value: 'name' },
    lastViewedOption: { text: 'Last Viewed', value: 'lastViewed' },
};

const sortByName = (cardA: CardWithBrand, cardB: CardWithBrand) => {
    const cardAName = (cardA.name || (cardA.brand?.name ?? '')) as string;
    const cardBName = (cardB.name || (cardB.brand?.name ?? '')) as string;

    return cardAName.localeCompare(cardBName);
};

const sortByDate = (
    cardA: CardWithBrand,
    cardB: CardWithBrand,
    getDate: (_: CardWithBrand | Card) => string | null
) => {
    const cardADateStr = getDate(cardA);
    const cardBDateStr = getDate(cardB);

    const cardADate = new Date(cardADateStr ? cardADateStr : 0);
    const cardBDate = new Date(cardBDateStr ? cardBDateStr : 0);

    return cardBDate.valueOf() - cardADate.valueOf();
};

export const sortCards = (cardA: CardWithBrand, cardB: CardWithBrand, sortedBy: SortOption) => {
    const [attr, sortDirection] = sortedBy.value.split(':');
    switch (attr) {
        case 'addedRecently': {
            return sortByDate(cardA, cardB, (card: CardWithBrand) =>
                card.type === ProductType.EGiftCard ? card.activationDate : card.registeredDate
            );
        }
        case 'amount': {
            const ascSort = (cardA.cardBalance || 0) - (cardB.cardBalance || 0);
            const descSort = (cardB.cardBalance || 0) - (cardA.cardBalance || 0);

            return sortDirection === 'desc' ? descSort : ascSort;
        }
        case 'lastViewed': {
            return sortByDate(cardA, cardB, (card: CardWithBrand) => card.lastViewedDate);
        }
        case 'name': {
            return sortByName(cardA, cardB);
        }
        default:
            return 1;
    }
};
